import { render } from "./PrintInvoiceWordsDesign4.vue?vue&type=template&id=2a378e3e&scoped=true"
import script from "./PrintInvoiceWordsDesign4.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceWordsDesign4.vue?vue&type=script&lang=js"

import "./PrintInvoiceWordsDesign4.vue?vue&type=style&index=0&id=2a378e3e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a378e3e"]])

export default __exports__